import React from 'react';
import styled from 'styled-components';

const TesteContainer = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  font-family: 'Roboto', sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const Heading = styled.h1`
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Section = styled.div`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #3498db;
  margin: 1.5rem 0 1rem 0;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
`;

const List = styled.ul`
  list-style-type: disc;
  padding-left: 1.5rem;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const Teste0306 = () => {
  return (
    <TesteContainer>
      <h3><b>Lançamento Residencial Jardim Pau-Brasil: Realize o Sonho da Casa Própria</b></h3>
      <p>
        <span className="citation">A EngenhArq apresenta o seu mais novo empreendimento, o <b>Jardim Pau-Brasil</b> <sup>[1, 2, 3, 4, 5, 6, 7]</sup></span>, um projeto que se enquadra no programa Minha Casa Minha Vida<sup>[2]</sup>. <span className="citation">Com o lema "Construindo Sonhos"<sup>[1, 2, 3, 4, 6, 7, 10, 11, 12]</sup></span>, o residencial oferece uma oportunidade única para quem busca um novo lar.
      </p>
      <p>
        <span className="citation">Uma das principais vantagens do Jardim Pau-Brasil é sua localização privilegiada, situado em frente a um shopping<sup>[3]</sup></span>, proporcionando comodidade e fácil acesso a serviços e lazer.
      </p>
      <Section>
        <SectionTitle>Condições Especiais de Lançamento</SectionTitle>
        <p>A construtora oferece condições facilitadas para a aquisição de uma das unidades. <span className="citation">Conforme a simulação para a casa A-73, com valor total de R$ 230.000,00, as condições de pagamento são<sup>[13]</sup>:</span></p>
        <List>
          <ListItem><span className="citation"><b>Entrada:</b> R$ 53.672,44 de recursos próprios, sendo R$ 10.000,00 na assinatura do pré-contrato, R$ 5.000,00 na entrega das chaves e o saldo de R$ 38.672,44 parcelado em 100 vezes de R$ 386,72 (corrigidos pelo IGPM + 1,2%)<sup>[12, 13]</sup>.</span></ListItem>
          <ListItem><span className="citation"><b>Financiamento:</b> O valor restante de R$ 176.327,56 deverá ser obtido por meio de financiamento junto à Caixa Econômica Federal, sujeito à análise e aprovação de crédito<sup>[13]</sup>.</span></ListItem>
          <ListItem><span className="citation"><b>Benefícios Adicionais:</b> Desconto de até R$ 55.000,00 e isenção de custos com cartório, ITBI e despachante<sup>[11]</sup>.</span></ListItem>
        </List>
        <p><span className="citation">A oferta é válida até <b>02 de novembro de 2024</b><sup>[15]</sup>.</span></p>
      </Section>
      <Section>
        <SectionTitle>Informações Importantes</SectionTitle>
        <List>
          <ListItem><span className="citation">As imagens utilizadas no material de divulgação são meramente ilustrativas e correspondem ao Condomínio Residencial Girassóis, um empreendimento com especificações similares<sup>[12, 16]</sup>.</span></ListItem>
          <ListItem><span className="citation">Itens como acabamentos, decoração, móveis, armários e eletrodomésticos não estão inclusos na venda das unidades<sup>[12]</sup>.</span></ListItem>
          <ListItem><span className="citation">O empreendimento será entregue em conformidade com o memorial de incorporação registrado em cartório e o projeto aprovado pela prefeitura<sup>[12]</sup>.</span></ListItem>
          <ListItem><span className="citation">A escolha da localização da casa dentro do condomínio é de responsabilidade do cliente, que deve visitar o local da obra<sup>[14, 15]</sup>.</span></ListItem>
        </List>
      </Section>
    </TesteContainer>
  );
}

export default Teste0306;
